export default __webpack_public_path__ + "static/media/nara.3fd261d8.jpeg";